import i18n from '@plugins/i18n';

export enum ScudRoles {
  NinaSuperAdmin = 'nina.super_user',
  NinaResponsableCG = 'nina.responsable_cg',
  NinaAssistantCG = 'nina.assistant_cg',
  NinaAgency = 'nina.agence',
}

export const Roles: { [key in ScudRoles]: string } = {
  [ScudRoles.NinaSuperAdmin]: i18n.t('system.roles.nina.super_user'),
  [ScudRoles.NinaResponsableCG]: i18n.t('system.roles.nina.responsable_cg'),
  [ScudRoles.NinaAssistantCG]: i18n.t('system.roles.nina.assistant_cg'),
  [ScudRoles.NinaAgency]: i18n.t('system.roles.nina.agence'),
};

export enum AllowedScopeLevel {
  SuperAdmin = 'super_admin',
  ManagementCenter = 'management_center',
  Agency = 'agency',
  Self = 'self',
}
